function t(t){return(r={})=>{const d=r.width?String(r.width):t.defaultWidth;return t.formats[d]||t.formats[t.defaultWidth]}}export{t as buildFormatLongFn};
//# sourceMappingURL=buildFormatLongFn.js.map
